import { UIFilters } from './ExploreTable/types'

const existence = (value: unknown) => {
  return value !== undefined ? 1 : 0
}

const filterCounter: {
  [TKey in keyof UIFilters]-?: (value: UIFilters[TKey]) => number
} = {
  locations: (val) => (val?.length ? 1 : 0),
  isActive: existence,
  religiousAffiliation: (val) => (val?.length ? 1 : 0),
  isTitle1Eligible: existence,
  schoolType: existence,
  virtual: existence,
  collegeFair: existence,
  title1Program: existence,
  classSize: (val) => (val?.min !== undefined || val?.max !== undefined ? 1 : 0),
  pctFreeReducedLunch: (val) => (val?.min !== undefined || val?.max !== undefined ? 1 : 0),
  pctFirstGenerationStudents: (val) => (val?.min !== undefined || val?.max !== undefined ? 1 : 0),
  pctAttendFourYearCollegeStudents: (val) => (val?.min !== undefined || val?.max !== undefined ? 1 : 0),
  pctAttendTwoYearCollegeStudents: (val) => (val?.min !== undefined || val?.max !== undefined ? 1 : 0),
  pctWhiteCaucasianStudents: (val) => (val?.min !== undefined || val?.max !== undefined ? 1 : 0),
  pctBlackAfricanAmericanStudents: (val) => (val?.min !== undefined || val?.max !== undefined ? 1 : 0),
  pctHispanicLatinoStudents: (val) => (val?.min !== undefined || val?.max !== undefined ? 1 : 0),
  pctAsianStudents: (val) => (val?.min !== undefined || val?.max !== undefined ? 1 : 0),
  pctNativeAmericanStudents: (val) => (val?.min !== undefined || val?.max !== undefined ? 1 : 0),
  pctOtherUndisclosedStudents: (val) => (val?.min !== undefined || val?.max !== undefined ? 1 : 0),
  visitRange: (val) => existence(val?.type),
  text: (val) => (val?.length ? 1 : 0),
  locale: existence,
  cities: (val) => (val?.length ? 1 : 0),
  zipCodes: (val) => (val?.length ? 1 : 0),
  geomarkets: (val) => (val?.length ? 1 : 0),
  interestedHandraisers: (val) => (val?.min !== undefined || val?.max !== undefined ? 1 : 0),
  interestedFollowers: (val) => (val?.min !== undefined || val?.max !== undefined ? 1 : 0),
  historicFollowers: (val) => (val?.min !== undefined || val?.max !== undefined ? 1 : 0),
  hasCounselorSuggestions: existence,
  isTarget: existence,
} as const

const getFilterCount = (filters: UIFilters): number => {
  let count = 0
  for (const key in filterCounter) {
    const keyName = key as keyof typeof filterCounter
    const fn = filterCounter[keyName] as (value: UIFilters[typeof keyName]) => number
    count += fn(filters[keyName])
  }
  return count
}

export default getFilterCount
